/**
 * @generated SignedSource<<9c7cc7a77b029af07b0ab460d710c9ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e7153dc33f2cc459cd3370edd8403d11";

export default node;
